import React from 'react';

import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import globalMessages from 'translations/messages/global-messages';

const QRCode = ({ size, title = '', intl, color, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{title || intl.formatMessage(globalMessages.qr_code_scan)}</title>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M2 3C2 2.44772 2.44772 2 3 2H7.15384C7.70612 2 8.15384 2.44772 8.15384 3V7.15385C8.15384 7.70613 7.70612 8.15385 7.15384 8.15385H3C2.44772 8.15385 2 7.70613 2 7.15385V3ZM4 4V6.15385H6.15384V4H4Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M15.8469 3C15.8469 2.44772 16.2946 2 16.8469 2H21.0007C21.553 2 22.0007 2.44772 22.0007 3V7.15385C22.0007 7.70613 21.553 8.15385 21.0007 8.15385H16.8469C16.2946 8.15385 15.8469 7.70613 15.8469 7.15385V3ZM17.8469 4V6.15385H20.0007V4H17.8469Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M2 16.8462C2 16.2939 2.44772 15.8462 3 15.8462H7.15384C7.70612 15.8462 8.15384 16.2939 8.15384 16.8462V21C8.15384 21.5523 7.70612 22 7.15384 22H3C2.44772 22 2 21.5523 2 21V16.8462ZM4 17.8462V20H6.15384V17.8462H4Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M16.8467 15.8462C17.399 15.8462 17.8467 16.2939 17.8467 16.8462V20H20.0005V17.8462H19.6159C19.0636 17.8462 18.6159 17.3984 18.6159 16.8462C18.6159 16.2939 19.0636 15.8462 19.6159 15.8462H21.0005C21.5528 15.8462 22.0005 16.2939 22.0005 16.8462V21C22.0005 21.5523 21.5528 22 21.0005 22H16.8467C16.2944 22 15.8467 21.5523 15.8467 21V16.8462C15.8467 16.2939 16.2944 15.8462 16.8467 15.8462Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M8.92215 3C8.92215 2.44772 9.36986 2 9.92215 2H14.076C14.6283 2 15.076 2.44772 15.076 3C15.076 3.55228 14.6283 4 14.076 4H10.9221V6.46154C10.9221 7.01382 10.4744 7.46154 9.92215 7.46154C9.36986 7.46154 8.92215 7.01382 8.92215 6.46154V3Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M14.0776 4.76927C14.6299 4.76927 15.0776 5.21699 15.0776 5.76927V10.6154C15.0776 11.1677 14.6299 11.6154 14.0776 11.6154C13.5254 11.6154 13.0776 11.1677 13.0776 10.6154V5.76927C13.0776 5.21699 13.5254 4.76927 14.0776 4.76927Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M9.92306 9.61546C10.4753 9.61546 10.9231 10.0632 10.9231 10.6155V14.077C10.9231 14.6293 10.4753 15.077 9.92306 15.077H3C2.44772 15.077 2 14.6293 2 14.077C2 13.5247 2.44772 13.077 3 13.077H8.92306V10.6155C8.92306 10.0632 9.37078 9.61546 9.92306 9.61546Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M9.92236 15.8462C10.4746 15.8462 10.9224 16.2939 10.9224 16.8462V20H14.0762C14.6285 20 15.0762 20.4477 15.0762 21C15.0762 21.5523 14.6285 22 14.0762 22H9.92236C9.37008 22 8.92236 21.5523 8.92236 21V16.8462C8.92236 16.2939 9.37008 15.8462 9.92236 15.8462Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M11.6919 16.8462C11.6919 16.2939 12.1396 15.8462 12.6919 15.8462H14.0765C14.6288 15.8462 15.0765 16.2939 15.0765 16.8462C15.0765 17.3984 14.6288 17.8462 14.0765 17.8462H12.6919C12.1396 17.8462 11.6919 17.3984 11.6919 16.8462Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M2 9.9231C2 9.37081 2.44772 8.9231 3 8.9231H7.15384C7.70612 8.9231 8.15384 9.37081 8.15384 9.9231C8.15384 10.4754 7.70612 10.9231 7.15384 10.9231H3C2.44772 10.9231 2 10.4754 2 9.9231Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M15.8467 9.9231C15.8467 9.37081 16.2944 8.9231 16.8467 8.9231H21.0005C21.5528 8.9231 22.0005 9.37081 22.0005 9.9231C22.0005 10.4754 21.5528 10.9231 21.0005 10.9231H17.8467V11.3077C17.8467 11.86 17.399 12.3077 16.8467 12.3077C16.2944 12.3077 15.8467 11.86 15.8467 11.3077V9.9231Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M11.6919 14.0769C11.6919 13.5246 12.1396 13.0769 12.6919 13.0769H20.9996C21.5519 13.0769 21.9996 13.5246 21.9996 14.0769C21.9996 14.6292 21.5519 15.0769 20.9996 15.0769H12.6919C12.1396 15.0769 11.6919 14.6292 11.6919 14.0769Z"
      />
    </svg>
  );
};

QRCode.propTypes = {
  title: PropTypes.string,
  intl: PropTypes.object.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
};

export default injectIntl(QRCode);
